import Flex from '@Components/Bases/Flex';
import FormTextAreaAutoSize from '@Components/Form/FormTextAreaAutosize';
import { disabledTextAreaInputStyles } from '@Components/Form/styles';
import { InputLabel, Typography } from '@mui/material';
import { validateTextEn } from '@Utils/validation';

type StakeholderExpectationsResponseProps = {
  isCompletedTh?: boolean;
  isCompletedEn?: boolean;
};

const StakeholderExpectationsResponse = ({
  isCompletedTh,
  isCompletedEn,
}: StakeholderExpectationsResponseProps) => {
  return (
    <Flex flexDirection="column">
      <Typography fontWeight={'bold'} mb={2}>
        การตอบสนองต่อความคาดหวังของผู้มีส่วนได้เสีย (ถ้ามี)
      </Typography>
      <Flex>
        <InputLabel
          sx={{
            textAlign: 'right',
            marginRight: 2,
            width: '100%',
            whiteSpace: 'pre-wrap',
            height: 'fit-content',
            marginTop: '23px',
          }}
        >
          การตอบสนองต่อความคาดหวังของ{'\n'}ผู้มีส่วนได้เสีย
        </InputLabel>
        <Flex gap={1} minWidth={600}>
          <FormTextAreaAutoSize
            label="ภาษาไทย"
            name="respondingToExpectationTh"
            inputProps={{
              placeholder:
                'กรุณาระบุการตอบสนองต่อความคาดหวังของผู้มีส่วนได้เสีย (ไทย)',
              minRows: 3,
              readOnly: isCompletedTh,
              tabIndex: isCompletedTh ? -1 : undefined,
            }}
            sx={isCompletedTh ? disabledTextAreaInputStyles : {}}
            flex={1}
            minWidth={200}
          />
          <FormTextAreaAutoSize
            label="ภาษาอังกฤษ"
            name="respondingToExpectationEn"
            inputProps={{
              placeholder:
                'กรุณาระบุการตอบสนองต่อความคาดหวังของผู้มีส่วนได้เสีย (อังกฤษ)',
              minRows: 3,
              readOnly: isCompletedEn,
              tabIndex: isCompletedEn ? -1 : undefined,
            }}
            sx={isCompletedEn ? disabledTextAreaInputStyles : {}}
            flex={1}
            minWidth={200}
            rules={{
              pattern: {
                value: validateTextEn,
                message:
                  'กรุณาระบุการตอบสนองต่อความคาดหวังของผู้มีส่วนได้เสียเป็นภาษาอังกฤษ',
              },
            }}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default StakeholderExpectationsResponse;
